export const aboutUsData = {
  sectionHeading: {
    title: 'About Us',
    text: 'Car Insurance Made Simple: Your Guide to Smarter Coverage with Finance Razor'
  },
  infoCards: [
    {
      icon: {
        src: "assets/about-us/searchService.svg",
        alt: ""
      },
      info: "At Finance Razor, we help drivers make informed car insurance decisions by connecting them with top-rated providers. Our platform simplifies the process of finding the right coverage at competitive rates. While we strive to provide accurate and up-to-date information, insurance rates and offers may change based on provider policies."
    },
    {
      icon: {
        src: "assets/about-us/emergency.svg",
        alt: ""
      },
      info: "We are not an insurance provider or broker but a trusted resource for comparing coverage options. Final policy decisions, including terms and pricing, are determined by the insurance providers. We encourage users to review all policy details carefully before making a decision. Finance Razor makes the search for car insurance easier, saving you time and effort."
    },
    {
      icon: {
        src: "assets/about-us/user.svg",
        alt: ""
      },
      info: "Looking for affordable and reliable car insurance? We connect you with top-rated providers in your area. Compare rates, coverage options, and benefits side-by-side. Save time and money without sacrificing quality coverage. Our user-friendly platform makes it easy to find the best value. Get started now and protect what matters most."
    },
  ]
}
